import { AbstractControl, ValidationErrors } from '@angular/forms';

export class IonIntlTelInputValidators {
  public static phone(control: AbstractControl): ValidationErrors | null {
    const value = control?.value;

    if (value === null || value === undefined || value === '') {
      return null;
    }

    if (typeof value === 'string') {
      return value.trim().length > 0 ? null : { phone: true };
    }

    const internationalNumber = String(value?.internationalNumber || '').trim();
    const nationalNumber = String(value?.nationalNumber || '').trim();

    return internationalNumber || nationalNumber ? null : { phone: true };
  }
}
